import Plate from './Plate';

export default Plate;
